<app-system-app-nav-bar />
<div class="main-content error-handling">
  <div class="container text-center h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-12 col-md-10 col-xl-8">
        <h2 class="text-red font-weight-normal border-bottom mb-4 pb-4">
          <i class="material-icons mi-inline mr-2" style="font-size: 48px">warning</i>
          <span>{{ '$500_internal_server_error$' | translate }}</span>
        </h2>
        <h5 class="font-weight-bold mb-2">
          {{ '$the_server_responded_with_a_500_internal_server_error$' | translate }}
        </h5>
        <p class="mb-4">{{ '$error_500_body$' | translate }}</p>
        <button class="btn btn-primary btn-capsule mx-auto" (click)="goToDashboard()">
          {{ '$button_back_to_dashboard$' | translate
          }}<i class="material-icons mi-inline ml-4">subdirectory_arrow_right</i>
        </button>
      </div>
    </div>
  </div>
</div>
